import { render, staticRenderFns } from "./business-consulting.vue?vue&type=template&id=fd2db3be&"
import script from "./business-consulting.vue?vue&type=script&lang=js&"
export * from "./business-consulting.vue?vue&type=script&lang=js&"
import style0 from "./business-consulting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports